import { useEffect, useMemo } from 'react';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  media: File[];
  onRemove: (file: File) => void;
};

export const NewPostMediaPreview = ({ media, onRemove }: Props) => {
  const items = useMemo(
    () =>
      media.map((file) => ({
        file,
        url: URL.createObjectURL(file),
        isVideo: file.type.startsWith('video'),
      })),
    [media],
  );

  useEffect(
    () => () => items.forEach((item) => URL.revokeObjectURL(item.url)),
    [items],
  );

  if (media.length === 0) return null;

  return (
    <div className="flex flex-row flex-wrap gap-3">
      {items.map((item) => (
        <div key={item.url} className="relative w-fit">
          <button
            type="button"
            aria-label={`Remove ${item.file.name}`}
            onClick={() => onRemove(item.file)}
            className="absolute -right-2 -top-2 flex size-5 items-center justify-center rounded-full bg-white text-xs text-gray-1 shadow-[0px_0px_4px_rgba(0,0,0,0.15)]"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
          {item.isVideo ? (
            <video src={item.url} className="max-h-[138px] rounded-[10px]" />
          ) : (
            <img
              src={item.url}
              alt={item.file.name}
              className="max-h-[138px] rounded-[10px] object-cover"
            />
          )}
        </div>
      ))}
    </div>
  );
};
